import { render, staticRenderFns } from "./trialbalance.vue?vue&type=template&id=3bcea7d5"
import script from "./trialbalance.vue?vue&type=script&lang=js"
export * from "./trialbalance.vue?vue&type=script&lang=js"
import style0 from "./trialbalance.vue?vue&type=style&index=0&id=3bcea7d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports